import { normalizePhoneNumber } from '@philo/phone-utils';
import { RootState } from '../reducers';

export function getPhoneNumber({ authProgress }: RootState) {
  return authProgress.phoneNumber;
}

export function getEmailAddress({ authProgress }: RootState) {
  return authProgress.emailAddress;
}

export function getIsRegistering({ authProgress }: RootState) {
  return authProgress.isRegistering;
}

export function getIsEmailAuthentication({ authProgress }: RootState) {
  return authProgress.isEmailAuthentication;
}

export function getRestartLinkPath({ authProgress }: RootState) {
  return authProgress.restartLinkPath;
}

export function getIsEmailRegistration({ authProgress }: RootState) {
  return authProgress.isEmailRegistration;
}

export function getIsEduAuthentication({ authProgress }: RootState) {
  return authProgress.isEduAuthentication;
}

export function getNormalizedIdent(state: RootState) {
  const emailAddress = getEmailAddress(state);
  const phoneNumber = getPhoneNumber(state);
  const isEmailRegistration = getIsEmailRegistration(state);

  return isEmailRegistration ? emailAddress : normalizePhoneNumber(phoneNumber);
}
